import React, { useState } from "react";
import { User } from "../../../../__generated__/api";
import Avatar, { AvatarProps } from "../../../avatar/Avatar";
import Agents from "../../../pickers/agents/Agents";
import UserOverlay from "../../../user-overlay/UserOverlay";
import EditableLabel from "../editable-label/EditableLabel";
import Styles from "./User.module.scss";
import { LoggingHandler } from "../../../../contexts/logging/LoggingContext";

export default function AgentsDisplay({
    user, variant, allowOverlay, onChange, defaultText, shouldShowSelfFirst, metricPathPrefix,
}: {
    user: User | undefined | null,
    defaultText?: string,
    variant?: AvatarProps["variant"],
    allowOverlay?: boolean;
    shouldShowSelfFirst?: boolean;
    onChange?: (userId: string) => void;
    metricPathPrefix: string[]
}) {
    const [isHover, setHover] = useState(false);

    let userView = (
        <span className={Styles["user-name-container"]}>
            {user ? (
                <>
                    <Avatar src={user?.avatarUrl as string} variant={variant} />
                    <span className={Styles["user-name"]}>{user?.name}</span>
                </>
            ) : defaultText}
        </span>
    );

    if (allowOverlay && user) {
        userView = (
            <UserOverlay
                user={user}
                size="sm"
                placement="left"
                trigger="hover"
                onToggleShow={shouldShow => setHover(shouldShow)}
                shouldShow={isHover}
                metricPathPrefix={[...metricPathPrefix, "overlay"]}
            >
                {userView}
            </UserOverlay>
        );
    }

    if (onChange) {
        const onDone = (done: (() => void)) => (
            <Agents
                shouldShowMenu
                value={user?.id}
                shouldShowSelfFirst={shouldShowSelfFirst}
                onSelected={userId => {
                    done();
                    onChange?.(userId);
                    LoggingHandler.instance.metric([...metricPathPrefix, "change"]);
                }}
            />
        );
        userView = (
            <EditableLabel
                className={Styles.user}
                menu={onDone}
            >
                {userView}
            </EditableLabel>
        );
    }
    return userView;
}

AgentsDisplay.defaultProps = {
    variant: "xs",
    allowOverlay: true,
    onChange: undefined,
    defaultText: "Unknown",
    shouldShowSelfFirst: false,
};
